import { curry, filter, pipe } from 'lodash/fp';
import { Notification } from './Notifications.interfaces';

export interface DateRelative {
  unit: 'seconds' | 'minutes' | 'hours' | 'days' | 'some';
  value: number;
}

export const timeDifference = (current: any, previous: any): DateRelative => {
  const msPerMinute = 60 * 1000;
  const msPerHour = msPerMinute * 60;
  const msPerDay = msPerHour * 24;
  const msPerMonth = msPerDay * 30;
  const msPerYear = msPerDay * 365;

  const elapsed = current - previous;

  if (elapsed < msPerMinute) {
    return {
      value: Math.floor(elapsed / 1000),
      unit: 'seconds',
    };
  }
  if (elapsed < msPerHour) {
    return {
      value: Math.floor(elapsed / msPerMinute),
      unit: 'minutes',
    };
  }
  if (elapsed < msPerDay) {
    return {
      value: Math.floor(elapsed / msPerHour),
      unit: 'hours',
    };
  }
  if (elapsed < msPerMonth) {
    return {
      value: Math.floor(elapsed / msPerDay),
      unit: 'days',
    };
  }
  return {
    value: 0,
    unit: 'some',
  };
};

export const sortByPublicationDate = (direction: 'ASC' | 'DSC', notifications: Notification[]) => {
  const configDirection = direction || 'DSC';
  return [...notifications].sort((a, b) => {
    const dateA = Number(new Date(a.publicationDate));
    const dateB = Number(new Date(b.publicationDate));
    return configDirection === 'DSC' ? dateA - dateB : dateB - dateA;
  });
};

export const sortByFeatured = (notifications: Notification[]) => {
  const curriedOrtByPublicationDate = curry(sortByPublicationDate);
  const filterNotifications = (filterFn: (n: Notification) => boolean) =>
    pipe(filter(filterFn), curriedOrtByPublicationDate('ASC'))(notifications);

  const featuredNotifications = filterNotifications((n) => n.featured);
  const restNotifications = filterNotifications((n) => !n.featured);
  return featuredNotifications.concat(restNotifications);
};
